import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
//import { SharedService } from '../../shared/shared.service';
import { NetworkingService } from '../../shared/networking.service';

@Injectable()
export class TopUpService {
  
  private topUpDetails : Object;
  
  constructor(/*private sharedService : SharedService,*/ private apiService: NetworkingService ) { }

  submitFormDetails(formDetails) : Observable<any> {
        this.topUpDetails = {
        "iataNumber": formDetails.iataNumber,
        "newCreditLimit": formDetails.newCreditLimit,
        "isIncrement": formDetails.isIncrement
      }
      return this.apiService.post('/agency/update-credit', this.topUpDetails).map(
          response => { return response; },
          error => error
        );


    
	}

}



// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/create-agency/top-up/top-up.service.ts